// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { GitIntegrationPlatformSchema } from '../inputTypeSchemas/GitIntegrationPlatformSchema'
import { EntryPointSchema } from '../inputTypeSchemas/EntryPointSchema'

/////////////////////////////////////////
// APPLICATION ENTRY POINT SCHEMA
/////////////////////////////////////////

export const ApplicationEntryPointSchema = z.object({
  platform: GitIntegrationPlatformSchema,
  entryPoint: EntryPointSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  pullNumber: z.number().int(),
  prOwner: z.string(),
  ownerAvatar: z.string(),
  prTitle: z.string(),
  prUrl: z.string(),
  investigated: z.boolean(),
  enhancementStartedAt: z.coerce.date().nullable(),
  signalId: z.string().nullable(),
  fileName: z.string(),
  description: z.string(),
  codeSnippet: z.string(),
  isReachable: z.boolean(),
  allSubGraphsFailed: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ApplicationEntryPoint = z.infer<typeof ApplicationEntryPointSchema>

export default ApplicationEntryPointSchema;
